import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class ProductsService {
constructor(private httpService: HttpClient) { }

private endpoint: String = 'https://om-sai-enterprises-786-default-rtdb.firebaseio.com/';

getAboutProducts(){
  return this.httpService.get(`${this.endpoint}/about_product.json`);
}
getMarbles() {
  return this.httpService.get(`${this.endpoint}/marbles.json`);
}
getGranites() {
  return this.httpService.get(`${this.endpoint}/granites.json`);
}
getTerrazos() {
  return this.httpService.get(`${this.endpoint}/terazzos.json`);
}
getQuartzs() {
  return this.httpService.get(`${this.endpoint}/quartz.json`);
}
getKadappas(){
  return this.httpService.get(`${this.endpoint}/kadappas.json`);
}
}
